(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initInfinite(root) {
    if (!root || root.dataset.lmpInfiniteBound === 'true') return;
    root.dataset.lmpInfiniteBound = 'true';

    var grid = root.querySelector('[data-lmp-products-grid]');
    var button = root.querySelector('[data-lmp-load-more]');
    var panel = root.querySelector('[data-lmp-infinite-panel]');
    var sentinel = root.querySelector('[data-lmp-infinite-sentinel]');
    if (!grid) return;

    // Promotional tiles are content, never products. Recalculate after infinite-scroll batches.
    var promoConfigNode = grid.querySelector('[data-los-promo-config]');
    var promoConfig = null;
    try { if (promoConfigNode) promoConfig = JSON.parse(promoConfigNode.textContent); } catch (error) { promoConfig = null; }
    function renderPromos() {
      if (!promoConfig || (promoConfig.scope !== 'all' && ['therapiespiegel-zur-spiegeltherapie','aluminium-spiegel'].indexOf(promoConfig.collection) === -1)) return;
      grid.querySelectorAll('[data-los-inline-promo]').forEach(function (node) { node.remove(); });
      var demo = grid.querySelector('[data-los-inline-promo-demo]');
      if (demo) demo.remove();
      var products = Array.prototype.slice.call(grid.querySelectorAll('[data-lmp-product-card]'));
      var interval = Math.max(4, Number(promoConfig.interval) || 12);
      var target = promoConfig.url || '/collections/therapiespiegel-zur-spiegeltherapie';
      if (!target.startsWith('/') || target.startsWith('//')) target = '/collections/therapiespiegel-zur-spiegeltherapie';
      var positions = [];
      if (products.length > 0 && products.length < interval) positions.push(products.length);
      else for (var step = interval; step <= products.length; step += interval) positions.push(step);
      positions.forEach(function (i) {
        var card = document.createElement('article');
        card.className = 'los-inline-promo';
        card.setAttribute('data-los-inline-promo', '');
        var media = document.createElement('div');
        media.className = 'los-inline-promo__media';
        if (promoConfig.image && /^https:\/\//.test(promoConfig.image)) {
          var img = document.createElement('img');
          img.src = promoConfig.image;
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        } else {
          var mark = document.createElement('span');
          mark.className = 'los-inline-promo__mark';
          mark.textContent = '✦';
          media.appendChild(mark);
        }
        var body = document.createElement('div');
        body.className = 'los-inline-promo__content';
        var eyebrow = document.createElement('span');
        eyebrow.className = 'los-inline-promo__eyebrow';
        eyebrow.textContent = 'EMPFEHLUNG';
        var title = document.createElement('h3');
        title.textContent = promoConfig.title || 'Mehr entdecken';
        var description = document.createElement('p');
        description.textContent = promoConfig.description || '';
        var link = document.createElement('a');
        link.className = 'los-inline-promo__link';
        link.href = target;
        link.textContent = promoConfig.label || 'Mehr entdecken';
        body.append(eyebrow, title, description, link);
        card.append(media, body);
        products[i - 1].insertAdjacentElement('afterend', card);
      });
    }
    renderPromos();

    if (!button) return;

    var loading = false;
    var finished = false;
    var autoLoadPaused = false;

    function setLoading(isLoading) {
      loading = isLoading;
      button.disabled = isLoading;
      button.textContent = isLoading ? 'Produkte werden geladen ...' : 'Weitere Produkte laden';
      if (panel) panel.classList.toggle('is-loading', isLoading);
    }

    // Skip empty source pages caused by supplier-specific tile filtering.
    // Bound each batch to avoid unbounded requests when many pages are empty.
    function loadNext() {
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl || loading || finished) return;
      setLoading(true);
      var visited = Object.create(null);
      var checked = 0;
      var maxPagesPerBatch = 8;

      function fetchPage(url) {
        if (!url || visited[url] || checked >= maxPagesPerBatch) {
          button.setAttribute('data-next-url', url || '');
          autoLoadPaused = true;
          setLoading(false);
          return Promise.resolve();
        }
        // Only request pages from this storefront, never external URLs.
        var target;
        try { target = new URL(url, window.location.href); }
        catch (error) { throw new Error('Invalid pagination URL'); }
        if (target.origin !== window.location.origin) throw new Error('External pagination URL blocked');
        var currentPreviewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (currentPreviewId) target.searchParams.set('preview_theme_id', currentPreviewId);
        visited[url] = true;
        checked += 1;
        return fetch(target.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-lmp-products-grid]');
            if (!nextGrid) throw new Error('Product grid missing');
            var cards = Array.prototype.slice.call(nextGrid.querySelectorAll('[data-lmp-product-card]'));
            var nextButton = doc.querySelector('[data-lmp-load-more]');
            var followingUrl = nextButton ? nextButton.getAttribute('data-next-url') : '';
            if (cards.length) {
              var emptyNotice = grid.querySelector('.lmp-empty');
              if (emptyNotice) emptyNotice.remove();
              cards.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
              renderPromos();
              document.dispatchEvent(new CustomEvent('lmp:products:appended'));
            }
            if (followingUrl) button.setAttribute('data-next-url', followingUrl);
            if (!followingUrl) {
              finished = true;
              setLoading(false);
              if (panel) panel.innerHTML = '<p class="lmp-infinite-text lmp-infinite-text--done">Alle sichtbaren Produkte dieser Auswahl wurden geladen.</p>';
              return;
            }
            if (!cards.length && checked < maxPagesPerBatch && !visited[followingUrl]) {
              return fetchPage(followingUrl);
            }
            if (!cards.length && checked >= maxPagesPerBatch) autoLoadPaused = true;
            setLoading(false);
          });
      }

      fetchPage(nextUrl).catch(function () {
        autoLoadPaused = true;
        setLoading(false);
        button.textContent = 'Laden erneut versuchen';
      });
    }

    button.addEventListener('click', function () { autoLoadPaused = false; loadNext(); });

    // When the first Shopify page contains only suppressed vidaXL items,
    // continue to the next page without requiring a customer click.
    if (!grid.querySelector('[data-lmp-product-card]')) loadNext();

    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !autoLoadPaused) loadNext();
        });
      }, { rootMargin: '520px 0px 520px 0px' });
      observer.observe(sentinel);
    }
  }

  ready(function () {
    document.querySelectorAll('[data-lmp-infinite-root]').forEach(initInfinite);
  });
})();
